// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"52":"99b2e604","377":"eb1565f2","610":"fd16686e","747":"1ed8d4a4","937":"1ae39f6a","969":"75762e1d"}[chunkId] + ".css";
};